import React from 'react';

/**
 * GST registered Yes / No (PMS slice 3a-ii) — the engine's IsRegistered input.
 * Shared by the party masters' Billing & Tax section and the property modal.
 */
interface Props {
  value: boolean;
  onChange: (registered: boolean) => void;
  disabled?: boolean;
  label?: string;
}

const GstRegisteredToggle: React.FC<Props> = ({ value, onChange, disabled, label = 'GST registered' }) => (
  <div className="form-group" data-field="isGstRegistered">
    <label className="form-label">{label}</label>
    <div
      role="group"
      aria-label={label}
      style={{ display: 'inline-flex', border: '1px solid var(--border-color)', borderRadius: '6px', overflow: 'hidden', width: 'fit-content' }}
    >
      {[{ v: true, l: 'Yes' }, { v: false, l: 'No' }].map(({ v, l }) => (
        <button
          key={l}
          type="button"
          disabled={disabled}
          onClick={() => onChange(v)}
          aria-pressed={value === v}
          style={{
            padding: '0.4rem 1.1rem', border: 'none', cursor: disabled ? 'default' : 'pointer', fontSize: '0.85rem',
            background: value === v ? 'var(--primary)' : 'transparent',
            color: value === v ? '#fff' : 'var(--text-primary)',
          }}
        >
          {l}
        </button>
      ))}
    </div>
  </div>
);

export default GstRegisteredToggle;
